module.exports = __webpack_public_path__ + "static/datas-illustration-9d1402fdee838dee79bfe040f23ab633.svg";